module.exports = __webpack_public_path__ + "img/my.a3c4cc63.png";